<div class="toast__message-wrap">
    <div class="toast__message">{{ message }}</div>
</div>
